module.exports = __webpack_public_path__ + "static/media/HCMM343.4f52f9e3.jpg";